import React from 'react';
import { Box, Button } from '@mui/material';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';

interface PrintButtonProps {
  onClick: () => void;
  disabled: boolean;
}

export const PrintButton: React.FC<PrintButtonProps> = ({
  onClick,
  disabled
}) => {
  return (
    <Box sx={{ mb: 2, mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        variant="contained"
        color="secondary"
        onClick={onClick}
        startIcon={<LocalPrintshopIcon />}
        disabled={disabled}
      >
        担当者一括印刷
      </Button>
    </Box>
  );
};